import DynamicIcon from "../../components/global/DynamicIcon";
import PrimaryButton from "../../components/global/PrimaryButton";
import { useNavigate } from "react-router";

function AcessoNegado() {
  const navigate = useNavigate()
  return (
    <div className="w-full h-full items-center justify-center flex flex-col gap-6 p-4 text-center">
      <h1 className="font-semibold text-3xl">Acesso negado</h1>
      <p>Voce nao possui permissao para acessar essa tela.</p>
      <div className="w-[180px]">
        <PrimaryButton
          startIcon={<DynamicIcon nameIcon="HomeRounded" size={25} className="text-white" />}
          onClick={() => {
            navigate("/dashboard")
          }}>Ir para home</PrimaryButton>
      </div>
    </div>
  );
}

export default AcessoNegado;